// Response shapes for the conductor flag endpoints (/api/conductor/flags).
// These mirror merge-backend's ConductorFlag / ConductorFlagRule app models.
// Named with the Conductor prefix so they are not confused with MergeFlag or
// waffle switches, which are a different system entirely.

export interface ConductorFlagRule {
  tenants: string[];
  organization_ids: string[];
  integration_ids: string[];
  linked_account_ids: string[];
  blueprint_ids: string[];
  /** Rollout share in [0, 100], hashed on linked account when one is present. */
  percent: number | null;
  description: string;
  /** null means enabled; only false skips the rule during evaluation. */
  enabled: boolean | null;
}

export interface ConductorFlag {
  id: string | null;
  name: string;
  /** true forces the flag on everywhere; false and null both fall through to rules. */
  everyone: boolean | null;
  rules: ConductorFlagRule[];
  note: string;
  modified_at: string | null;
}

export const EMPTY_RULE: ConductorFlagRule = {
  tenants: [],
  organization_ids: [],
  integration_ids: [],
  linked_account_ids: [],
  blueprint_ids: [],
  percent: null,
  description: "",
  enabled: true,
};
